/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-charts/charts/charts';
import * as i2 from '../../../../../../app/components/reports/charts/totalFeeChart/totalFeeChart.component';
const styles_TotalFeeChartComponent:any[] = ([] as any[]);
export const RenderType_TotalFeeChartComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_TotalFeeChartComponent,data:{}});
export function View_TotalFeeChartComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{elementView:0}),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),5,'div',[['class','chart-wrapper']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵeld(0,[[1,0],['chart',1]],(null as any),2,'canvas',[['baseChart',
          ''],['height','150'],['width','400']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i0.ɵdid(737280,(null as any),0,i1.BaseChartDirective,
          [i0.ElementRef],{datasets:[0,'datasets'],labels:[1,'labels'],options:[2,
              'options'],chartType:[3,'chartType'],colors:[4,'colors'],legend:[5,'legend']},
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' ']))],(_ck,_v) => {
    var _co:i2.TotalFeeChartComponent = _v.component;
    const currVal_0:any = _co.lineChartData;
    const currVal_1:any = _co.lineChartLabels;
    const currVal_2:any = _co.lineChartOptions;
    const currVal_3:any = _co.lineChartType;
    const currVal_4:any = _co.lineChartColors;
    const currVal_5:any = _co.lineChartLegend;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5);
  },(null as any));
}
export function View_TotalFeeChartComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'chart-total-fee',
      ([] as any[]),(null as any),[['window','resize']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('window:resize' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,1).changeHeight()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },View_TotalFeeChartComponent_0,RenderType_TotalFeeChartComponent)),i0.ɵdid(114688,
      (null as any),0,i2.TotalFeeChartComponent,([] as any[]),(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const TotalFeeChartComponentNgFactory:i0.ComponentFactory<i2.TotalFeeChartComponent> = i0.ɵccf('chart-total-fee',
    i2.TotalFeeChartComponent,View_TotalFeeChartComponent_Host_0,{totalFeeResponses:'totalFeeResponses',
        showCurrency:'showCurrency',showTotal:'showTotal',showLegend:'showLegend',
        agentColors:'agentColors',agentSelectorComponent:'agentSelectorComponent'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9jaGFydHMvdG90YWxGZWVDaGFydC90b3RhbEZlZUNoYXJ0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL2NoYXJ0cy90b3RhbEZlZUNoYXJ0L3RvdGFsRmVlQ2hhcnQuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9jaGFydHMvdG90YWxGZWVDaGFydC90b3RhbEZlZUNoYXJ0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy9jaGFydHMvdG90YWxGZWVDaGFydC90b3RhbEZlZUNoYXJ0LmNvbXBvbmVudC50cy5Ub3RhbEZlZUNoYXJ0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImNoYXJ0LXdyYXBwZXJcIj4gPGNhbnZhcyBiYXNlQ2hhcnQgd2lkdGg9XCI0MDBcIiBoZWlnaHQ9XCIxNTBcIiAjY2hhcnQgW2RhdGFzZXRzXT1cImxpbmVDaGFydERhdGFcIiBbbGFiZWxzXT1cImxpbmVDaGFydExhYmVsc1wiIFtvcHRpb25zXT1cImxpbmVDaGFydE9wdGlvbnNcIiBbY29sb3JzXT1cImxpbmVDaGFydENvbG9yc1wiIFtsZWdlbmRdPVwibGluZUNoYXJ0TGVnZW5kXCIgW2NoYXJ0VHlwZV09XCJsaW5lQ2hhcnRUeXBlXCI+IDwvY2FudmFzPiA8L2Rpdj4iLCI8Y2hhcnQtdG90YWwtZmVlPjwvY2hhcnQtdG90YWwtZmVlPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozt5RENBQTtNQUFBO01BQUEsNENBQTJCO01BQUM7VUFBQTtVQUFBLHFDQUFBO1VBQUE7Y0FBQTtVQUFBLGVBQXVOLHNDQUFVO1VBQUE7O0lBQS9LO0lBQTJCO0lBQTJCO0lBQW1GO0lBQXREO0lBQTJCO0lBQWhLLFdBQWtELFVBQTJCLFVBQTJCLFVBQW1GLFVBQXRELFVBQTJCLFNBQWhLOzs7O29CQ0E1QjtNQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFBO01BQUEsMkVBQUE7TUFBQTs7UUFBQTs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./compiled/app/components/reports/charts/totalFeeChart/totalFeeChart.component.ngfactory.ts